__turbopack_context__.v({
  "caption": "LandingPageContent-module__teq0hG__caption",
  "deactivatedlink": "LandingPageContent-module__teq0hG__deactivatedlink",
  "divider": "LandingPageContent-module__teq0hG__divider",
  "introline": "LandingPageContent-module__teq0hG__introline",
  "introtext": "LandingPageContent-module__teq0hG__introtext",
  "linkdivider": "LandingPageContent-module__teq0hG__linkdivider",
  "links": "LandingPageContent-module__teq0hG__links",
  "me": "LandingPageContent-module__teq0hG__me",
  "meimg": "LandingPageContent-module__teq0hG__meimg",
  "metadata": "LandingPageContent-module__teq0hG__metadata",
  "sectionEyebrow": "LandingPageContent-module__teq0hG__sectionEyebrow",
  "thanks": "LandingPageContent-module__teq0hG__thanks",
  "thankswrapper": "LandingPageContent-module__teq0hG__thankswrapper",
  "wrapper": "LandingPageContent-module__teq0hG__wrapper",
});
